import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import * as UIActions from '../../actions/uiAction';
import * as UserActions from '../../actions/userAction';

class Profile extends Component {
    constructor(props) {
        super(props);
        const { firstName, lastName, email, contactNo, billAddr, schoolName, graduateAt, targetTest, targetTestDate } = props.UserStore.userInfo
        this.initPersonalInfo = {
            firstName: {
                value: firstName,
                invalidField: false
            },
            lastName: {
                value: lastName,
                invalidField: false
            },
            contactNo: {
                value: contactNo,
                invalidField: null
            },
            email: {
                value: email,
                invalidField: false
            },
            billAddr: {
                value: billAddr,
                invalidField: null
            },
            schoolName: {
                value: schoolName,
                invalidField: null
            },
            graduateAt: {
                value: graduateAt,
                invalidField: null
            },
            targetTest: {
                value: targetTest,
                invalidField: null
            },
            targetTestDate: {
                value: targetTestDate,
                invalidField: null
            }
        }

        this.state = {
            editMode: false,
            personalInfo: this.initPersonalInfo,
            statePersonalInfo: this.initPersonalInfo
        }
    }

    runValidation = (target) => {
        const { firstName, lastName, contactNo, email, password, confirmPassword } = this.state.statePersonalInfo
        const id = target ? target.id : null
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
        let invalidField = false
        let errMsg = null

        switch (id) {
            case "firstName": {
                if (!firstName.value.length) {
                    invalidField = true
                    errMsg = "Please enter your first name"
                    break
                } else break
            }
            case "lastName": {
                if (!lastName.value.length) {
                    invalidField = true
                    errMsg = "Please enter your last name"
                    break
                } else break
            }
            case "email": {
                if (!email.value.length) {
                    invalidField = true
                    errMsg = "Please enter your email"
                    break
                } else if (!emailRegex.test(email.value)) {
                    invalidField = true
                    errMsg = "Please enter a valid email"
                    break
                } else break
            }
            case "contactNo": {
                if (!contactNo.value.length > 8) {
                    invalidField = true
                    errMsg = "Please enter a valid contact number"
                    break
                } else break
            }
            // case "password": {
            //     if (!password.value.length) {
            //         invalidField = true
            //         errMsg = "Please enter your password"
            //         break
            //     } else if (!pwdRegex.test(password.value)) {
            //         invalidField = true
            //         errMsg = "Password must contains min. 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
            //         break
            //     } else break
            // }
            // case "confirmPassword": {
            //     if (confirmPassword.value !== password.value) {
            //         invalidField = true
            //         errMsg = "Your password did not match"
            //         break
            //     } else break
            // }
            default: {
                if (
                    firstName.invalidField
                    || firstName.invalidField === null
                    || lastName.invalidField
                    || lastName.invalidField === null
                    || email.invalidField
                    || email.invalidField === null
                    || contactNo.invalidField
                    // || password.invalidField
                    // || password.invalidField === null
                    // || confirmPassword.invalidField
                    // || confirmPassword.invalidField === null
                ) {
                    if (firstName.invalidField || firstName.invalidField === null) {
                        this.setState({
                            firstName: {
                                ...this.state.firstName,
                                invalidField: true
                            }
                        })
                    }
                    if (lastName.invalidField || lastName.invalidField === null) {
                        this.setState({
                            lastName: {
                                ...this.state.lastName,
                                invalidField: true
                            }
                        })
                    }
                    if (email.invalidField || email.invalidField === null) {
                        this.setState({
                            email: {
                                ...this.state.email,
                                invalidField: true
                            }
                        })
                    }
                    // if (password.invalidField || password.invalidField === null) {
                    //     this.setState({
                    //         password: {
                    //             ...this.state.password,
                    //             invalidField: true
                    //         }
                    //     })
                    // }
                    // if (confirmPassword.invalidField || confirmPassword.invalidField === null) {
                    //     this.setState({
                    //         confirmPassword: {
                    //             ...this.state.confirmPassword,
                    //             invalidField: true
                    //         }
                    //     })
                    // }
                    this.props.addError('Please make sure all the field above is correctly entered')
                    return false
                } else return true
            }
        }

        if (errMsg) { this.props.addError(errMsg) }

        if (id) {
            this.setState({
                statePersonalInfo: {
                    ...this.state.statePersonalInfo,
                    [id]: {
                        ...this.state.statePersonalInfo[id],
                        invalidField
                    }
                }
            })
        }
    }

    handleInput = (target) => {
        const id = target.id
        const value = target.value

        this.setState({
            statePersonalInfo: {
                ...this.state.statePersonalInfo,
                [id]: {
                    ...this.state.statePersonalInfo[id],
                    value
                }
            }
        })
    }

    toogleBtn = () => {
        this.setState(prevState => ({
            editMode: !prevState.editMode
        }))
    }

    onCancel = () => {
        this.setState({
            ...this.state.statePersonalInfo
        }, () =>
            this.toogleBtn()
        )
    }

    onSave = () => {
        const { firstName, lastName, contactNo, email, billAddr, schoolName, graduateAt, targetTest, targetTestDate } = this.state.statePersonalInfo

        if (this.runValidation()) {
            let userInfo = {
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
            }
            if (contactNo.value && contactNo.value.length) userInfo.contactNo = contactNo.value
            if (billAddr.value && billAddr.value.length) userInfo.billAddr = billAddr.value
            if (schoolName.value && schoolName.value.length) userInfo.schoolName = schoolName.value
            if (graduateAt.value && graduateAt.value.length) userInfo.graduateAt = graduateAt.value
            if (targetTest.value && targetTest.value.length) userInfo.targetTest = targetTest.value
            if (targetTestDate.value && targetTestDate.value.length) userInfo.billAddr = billAddr.value

            this.props.updateUserInfo(userInfo)

            this.setState({
                personalInfo: this.state.statePersonalInfo,
            }, () => this.toogleBtn())
        }
    }

    render() {
        const { editMode, personalInfo: { firstName, lastName, contactNo, email, billAddr, schoolName, graduateAt, targetTest, targetTestDate }, statePersonalInfo } = this.state
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Sign Up Page</title>
                    <meta name="description" content="QBank Sign Up Page allowed new user to create an QBank account and the benific to be a QBank user." />
                </Helmet>
                <div className="profilePage">
                    <div className="qbCard">
                        <div className="fTitle">Personal Information</div>
                        <div className="qbForm">
                            <div className="qbRow">
                                {!editMode &&
                                    <div className="itemCont">
                                        <div className="fLabel">Name</div>
                                        <div className="qbInput">{firstName.value} {lastName.value}</div>
                                    </div>
                                }
                                {editMode &&
                                    <Fragment>
                                        <div className="itemCont">
                                            <div className="fLabel">First Name</div>
                                            <input
                                                id="firstName"
                                                type="text"
                                                defaultValue={statePersonalInfo.firstName.value}
                                                className={statePersonalInfo.firstName.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                                onChange={e => this.handleInput(e.target)}
                                                onBlur={e => this.runValidation(e.target)}
                                            />
                                        </div>
                                        <div className="itemCont">
                                            <div className="fLabel">Last Name</div>
                                            <input
                                                id="lastName"
                                                type="text"
                                                defaultValue={statePersonalInfo.lastName.value}
                                                className={statePersonalInfo.lastName.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                                onChange={e => this.handleInput(e.target)}
                                                onBlur={e => this.runValidation(e.target)}
                                            />
                                        </div>
                                    </Fragment>
                                }
                            </div>
                            <div className="qbRow">
                                <div className="itemCont">
                                    <div className="fLabel">Contact Number</div>
                                    {editMode ?
                                        <input
                                            id="contactNo"
                                            type="tel"
                                            defaultValue={statePersonalInfo.contactNo.value}
                                            className={statePersonalInfo.contactNo.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                            onBlur={e => this.runValidation(e.target)}
                                        />
                                        : <div className="qbInput">{contactNo.value || "Not available"}</div>
                                    }
                                </div>
                                <div className="itemCont">
                                    <div className="fLabel">Email</div>
                                    {editMode ?
                                        <input
                                            id="email"
                                            type="text"
                                            defaultValue={statePersonalInfo.email.value}
                                            className={statePersonalInfo.email.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                            onBlur={e => this.runValidation(e.target)}
                                        />
                                        : <div className="qbInput">{email.value}</div>
                                    }
                                </div>
                            </div>
                            <div className="itemCont">
                                <div className="fLabel">Billing Address</div>
                                {editMode ?
                                    <textarea
                                        id="billAddr"
                                        type="text"
                                        defaultValue={statePersonalInfo.billAddr.value}
                                        className={statePersonalInfo.billAddr.invalidField ? "qbTextarea allowEdit error" : "qbTextarea allowEdit"}
                                        onChange={e => this.handleInput(e.target)}
                                        onBlur={e => this.runValidation(e.target)}
                                    />
                                    : <div className="qbTextarea">{billAddr.value || "Not available"}</div>
                                }
                            </div>
                        </div>
                        <div className="fTitle">Education Information</div>
                        <div className="qbForm">
                            <div className="qbRow">
                                <div className="itemCont">
                                    <div className="fLabel">School Name</div>
                                    {editMode ?
                                        <input
                                            id="schoolName"
                                            type="text"
                                            defaultValue={statePersonalInfo.schoolName.value}
                                            className={statePersonalInfo.schoolName.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                            onBlur={e => this.runValidation(e.target)}
                                        />
                                        : <div className="qbInput">{schoolName.value || "Not available"}</div>
                                    }
                                </div>
                                <div className="itemCont">
                                    <div className="fLabel">Year of Graduation</div>
                                    {editMode ?
                                        <input
                                            id="graduateAt"
                                            type="text"
                                            defaultValue={statePersonalInfo.graduateAt.value}
                                            className={statePersonalInfo.graduateAt.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                            onBlur={e => this.runValidation(e.target)}
                                        />
                                        : <div className="qbInput">{graduateAt.value || "Not available"}</div>
                                    }
                                </div>
                            </div>
                            <div className="qbRow">
                                <div className="itemCont">
                                    <div className="fLabel">Target Test</div>
                                    {editMode ?
                                        <input
                                            id="targetTest"
                                            type="text"
                                            defaultValue={statePersonalInfo.targetTest.value}
                                            className={statePersonalInfo.targetTest.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                        />
                                        : <div className="qbInput">{targetTest.value || "Not available"}</div>
                                    }
                                </div>
                                <div className="itemCont">
                                    <div className="fLabel">Target Test Date</div>
                                    {editMode ?
                                        <input
                                            id="targetTestDate"
                                            type="date"
                                            defaultValue={statePersonalInfo.targetTestDate.value}
                                            className={statePersonalInfo.targetTestDate.invalidField ? "qbInput allowEdit error" : "qbInput allowEdit"}
                                            onChange={e => this.handleInput(e.target)}
                                        />
                                        : <div className="qbInput">{targetTestDate.value || "Not available"}</div>
                                    }
                                </div>
                            </div>
                            <div className="actionCont">
                                <div className={editMode ? "qbBtn solid" : "qbBtn"} onClick={() => editMode ? this.onSave() : this.toogleBtn()}>{editMode ? "SAVE" : "EDIT"}</div>
                                {!!editMode &&
                                    <div className="qbBtn" onClick={() => this.onCancel()}>CANCEL</div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="qbCard">
                        <div className="fTitle">Change Password</div>
                        <div className="qbForm">
                            <div className="qbRow">
                                <div className="itemCont">
                                    <div className="fLabel">Old Password</div>
                                    <input
                                        type="password"
                                        className="qbInput allowEdit"
                                    />
                                </div>
                            </div>
                            <div className="qbRow">
                                <div className="itemCont">
                                    <div className="fLabel">New Password</div>
                                    <input
                                        type="password"
                                        className="qbInput allowEdit"
                                    />
                                </div>
                                <div className="itemCont">
                                    <div className="fLabel">Confirm Password</div>
                                    <input
                                        type="password"
                                        className="qbInput allowEdit"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="actionCont">
                            <div className="qbBtn solid">UPDATE</div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ UserStore }) => ({
    UserStore
});

const mapDispatchToProps = (dispatch) => ({
    addError: (msg) => dispatch(UIActions.addError(msg)),
    showSuccess: (msg) => dispatch(UIActions.showSuccess(msg)),
    updateUserInfo: (data) => dispatch(UserActions.updateUserInfo(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));


// WEBPACK FOOTER //
// ./src/Components/profile/Profile.js